@if (gameLoaded) {
  <div>
    <!-- <h2>{{ i18n.str('challengeu.mp_wait_join', "Waiting to join")() }}</h2> -->
    <h2>@if (room.private) {
      <i class="fa fa-key"></i>
    } {{room.roomName}}</h2>
    @if (!room.active) {
      <h3>{{ i18n.str('challengeu.room_game_deactivated', 'Game has been deactivated')() }}</h3>
      <p class="jeopardy-button secondary" style="margin-right: 1em;">
        <a href="#" routerLink="/multiplayer">{{ i18n.str('challengeu.back', 'Back')() }}</a>
      </p>
    }
    @if (room.active) {
      <div style="margin-top: 2em;">
        <input type="text" maxlength="32" placeholder="{{ i18n.str('challengeu.mp_password', 'Password')() }}" style="width: 100%;" [(ngModel)]="accessCode">
      </div>
      <br>
        <p class="jeopardy-button secondary" style="margin-right: 1em;">
          <a href="#" routerLink="/multiplayer">{{ i18n.str('challengeu.cancel', 'Cancel')() }}</a>
        </p>
        <p class="jeopardy-button primary">
          <a href="#" (click)="joinRoom($event, room)">{{ i18n.str('challengeu.mp_join', 'Join')() }}</a>
        </p>
        @if (joinError) {
          <p>{{joinError}}</p>
        }
        <br><br><br><br>
        @if (room.players > 2) {
          <div>
            <div class="hostname">
              <div class="item">
                <img src="assets/app-branding/img/avatars/cartoon/{{host.avatar}}">
              </div>
              <div class="item">
                {{host.name}}
              </div>
            </div>
            <div class="vs">{{ i18n.str('challengeu.mp_vs', 'VS')() }}</div>
            <div class="users-joined">
              @for (player of players; track player) {
                <div>
                  @if (player.avatar) {
                    <img src="assets/app-branding/img/avatars/cartoon/{{player.avatar}}">
                  }
                  @if (!player.avatar) {
                    <img src="assets/app-branding/img/1chair.jpg">
                  }
                  <div>
                    {{player.name}}
                  </div>
                </div>
              }
              <!-- <div class="missing-player" *ngFor="let item of [].constructor(room.maxPlayers - players.length)">
              <img src="assets/app-branding/img/1chair.jpg">
            </div> -->
          </div>
        </div>
      }
      @if (room.players === 2) {
        <div>
          <div class="users-joined">
            <div>
              <img src="assets/app-branding/img/avatars/cartoon/{{host.avatar}}">
              <div>
                {{host.name}}
              </div>
            </div>
            <div class="vs">{{ i18n.str('challengeu.mp_vs', 'VS')() }}</div>
            <div>
              @if (!players[0].avatar) {
                <img style="width:3em" src="assets/app-branding/img/1chair.jpg">
              }
              @if (players[0].avatar) {
                <img src="assets/app-branding/img/avatars/cartoon/{{players[0].avatar}}">
              }
              <div>
                {{players[0].name}}
              </div>
            </div>
            <!-- <div class="missing-player" *ngFor="let item of [].constructor(room.maxPlayers - players.length)">
            <img src="assets/app-branding/img/1chair.jpg">
          </div> -->
        </div>
      </div>
    }
    <!-- <p class="jeopardy-button primary">
    <a href="#" routerLink="/multiplayer">START</a>
  </p> -->
}
</div>
}

